import CameraPicker from './CameraPicker';
import * as Mock from './CameraPicker.mock';
import { CameraPickerWeb } from "./CameraPickerWeb";
import { Platform } from "react-native";
let exportedModule;
if (Platform.OS !== 'web') {
    exportedModule = CameraPicker;
}
else {
    exportedModule = CameraPickerWeb;
}
export { exportedModule as Component, Mock };
